module.exports = __webpack_public_path__ + "img/16.5545178e.jpg";